export const isEmpty = (collection: ArrayLike<unknown> | Map<unknown, unknown>): boolean => {
  if (collection instanceof Map) {
    return collection.size < 1
  }

  return collection.length < 1
}
